export * from './detailed-description/DetailedDescription'
export * from './header/Header'
export * from './Main'
export * from './history/History'
export * from './process-details/ProcessDetails'
